import React, {useEffect, useState} from 'react';

import "react-datepicker/dist/react-datepicker.css";
import {useSearchParams} from "react-router-dom";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import PaymentSuccess from "./PaymentSuccess";

const CreditCardPaymentSuccess = (props) => {
  const [searchParams] = useSearchParams();
  const [isProcessing, setIsProcessing] = useState(true);
  const {executeRecaptcha} = useGoogleReCaptcha();

  const [inputValues, setInputValues] = useState({
    policyNumber: '',
    paymentFrequency: '',
    insuranceCover: '',
    vehicleValue: ''
  });

  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';

  useEffect(() => {
    if (executeRecaptcha) {
      fetchPaymentDetails();
    } else {
      console.log("reCAPTCHA is not ready");
    }
  }, [executeRecaptcha]);

  const fetchPaymentDetails = async () => {
    try {
      let uuid = searchParams.get("id");

      const response = await fetch(`${url}/vero/payment/policy/retrieve?uuid=${uuid}`, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `By-Pass-Auth-Create-Prospect`
        },
      });

      const json = await response.json();

      setInputValues({
        policyNumber: json.policyId,
        paymentFrequency: json.paymentFrequency,
        insuranceCover: json.cover,
        vehicleValue: json.amountCovered,
      });

      setIsProcessing(false);
    } catch (err) {
      setIsProcessing(false);
      console.error("Caught error: ", err);
      window.location.href = `/error-occurred`;
    }
  };
  return (
      <>
        <div>
          <br/>
          {isProcessing ? (
            <>
              <br/><br/>
              <p className="text-font-label" style={{height: "100%", minHeight: "55vh"}}>
                Please wait while we are processing your request...
                <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
              </p>
            </>
          ) : (
            // Conditionally render PaymentSuccess if inputValues contains data
            inputValues.policyNumber && inputValues.paymentFrequency && inputValues.insuranceCover && inputValues.vehicleValue ? (
              <PaymentSuccess inputValues={inputValues}/>
            ) : (
              <p className="text-font-label">
                Unable to load payment details. Please try again.
              </p>
            )
          )}
        </div>
      </>
  );

}

export default CreditCardPaymentSuccess;
